/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ItemsV2ControllerAutocomplete200,
  ItemsV2ControllerAutocompleteParams,
  ItemsV2ControllerBulkUploadSupplierPrices200,
  ItemsV2ControllerBulkUploadSupplierPricesBody,
  ItemsV2ControllerFindById200,
  ItemsV2ControllerGetItemSupplierComparison200,
  ItemsV2ControllerGetPopular200,
  ItemsV2ControllerGetPopularParams,
  ItemsV2ControllerGetSupplierItems200,
  ItemsV2ControllerGetSupplierPrice200,
  ItemsV2ControllerGetSupplierPriceParams,
} from "../client.schemas";

import { api } from "../../lib/orval-mutator";
import type { ErrorType, BodyType } from "../../lib/orval-mutator";

/**
 * 관리자가 내려준 양식(품목ID·신규단가·취급)에 값을 채워 올리면 로그인한 공급사의 단가로 반영된다. 이미 있는 품목은 덮어쓰고, 신규단가가 빈 행은 건드리지 않는다. 오류 행이 있어도 나머지는 반영되며 오류 목록을 함께 돌려준다.
 * @summary 내 단가 엑셀 일괄 등록
 */
export const itemsV2ControllerBulkUploadSupplierPrices = (
  itemsV2ControllerBulkUploadSupplierPricesBody: BodyType<ItemsV2ControllerBulkUploadSupplierPricesBody>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (itemsV2ControllerBulkUploadSupplierPricesBody.file !== undefined) {
    formData.append(`file`, itemsV2ControllerBulkUploadSupplierPricesBody.file);
  }

  return api<ItemsV2ControllerBulkUploadSupplierPrices200>({
    url: `/items-v2/supplier-prices/bulk-upload`,
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
    signal,
  });
};

export const getItemsV2ControllerBulkUploadSupplierPricesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof itemsV2ControllerBulkUploadSupplierPrices>>,
    TError,
    { data: BodyType<ItemsV2ControllerBulkUploadSupplierPricesBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof itemsV2ControllerBulkUploadSupplierPrices>>,
  TError,
  { data: BodyType<ItemsV2ControllerBulkUploadSupplierPricesBody> },
  TContext
> => {
  const mutationKey = ["itemsV2ControllerBulkUploadSupplierPrices"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof itemsV2ControllerBulkUploadSupplierPrices>>,
    { data: BodyType<ItemsV2ControllerBulkUploadSupplierPricesBody> }
  > = (props) => {
    const { data } = props ?? {};

    return itemsV2ControllerBulkUploadSupplierPrices(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ItemsV2ControllerBulkUploadSupplierPricesMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof itemsV2ControllerBulkUploadSupplierPrices>>
  >;
export type ItemsV2ControllerBulkUploadSupplierPricesMutationBody =
  BodyType<ItemsV2ControllerBulkUploadSupplierPricesBody>;
export type ItemsV2ControllerBulkUploadSupplierPricesMutationError =
  ErrorType<unknown>;

/**
 * @summary 내 단가 엑셀 일괄 등록
 */
export const useItemsV2ControllerBulkUploadSupplierPrices = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof itemsV2ControllerBulkUploadSupplierPrices>>,
      TError,
      { data: BodyType<ItemsV2ControllerBulkUploadSupplierPricesBody> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof itemsV2ControllerBulkUploadSupplierPrices>>,
  TError,
  { data: BodyType<ItemsV2ControllerBulkUploadSupplierPricesBody> },
  TContext
> => {
  const mutationOptions =
    getItemsV2ControllerBulkUploadSupplierPricesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 
      정부 조달 데이터(items_v2_base) 기반 품목 검색. 상품명, cat1, cat2 필드에서 검색.

      **일반 사용자**: referencePrice, lowestPrice 반환
      **공급사 사용자**: supplierId 파라미터 제공 시 supplierPrice (공급사별 단가) 추가 반환
    
 * @summary 품목 자동완성 검색 (items-v2, 한글 유사 검색 .ilike, 최소 2자)
 */
export const itemsV2ControllerAutocomplete = (
  params: ItemsV2ControllerAutocompleteParams,
  signal?: AbortSignal,
) => {
  return api<ItemsV2ControllerAutocomplete200>({
    url: `/items-v2/autocomplete`,
    method: "GET",
    params,
    signal,
  });
};

export const getItemsV2ControllerAutocompleteQueryKey = (
  params?: ItemsV2ControllerAutocompleteParams,
) => {
  return [`/items-v2/autocomplete`, ...(params ? [params] : [])] as const;
};

export const getItemsV2ControllerAutocompleteQueryOptions = <
  TData = Awaited<ReturnType<typeof itemsV2ControllerAutocomplete>>,
  TError = ErrorType<unknown>,
>(
  params: ItemsV2ControllerAutocompleteParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerAutocomplete>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getItemsV2ControllerAutocompleteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof itemsV2ControllerAutocomplete>>
  > = ({ signal }) => itemsV2ControllerAutocomplete(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof itemsV2ControllerAutocomplete>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ItemsV2ControllerAutocompleteQueryResult = NonNullable<
  Awaited<ReturnType<typeof itemsV2ControllerAutocomplete>>
>;
export type ItemsV2ControllerAutocompleteQueryError = ErrorType<unknown>;

export function useItemsV2ControllerAutocomplete<
  TData = Awaited<ReturnType<typeof itemsV2ControllerAutocomplete>>,
  TError = ErrorType<unknown>,
>(
  params: ItemsV2ControllerAutocompleteParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerAutocomplete>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemsV2ControllerAutocomplete>>,
          TError,
          Awaited<ReturnType<typeof itemsV2ControllerAutocomplete>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemsV2ControllerAutocomplete<
  TData = Awaited<ReturnType<typeof itemsV2ControllerAutocomplete>>,
  TError = ErrorType<unknown>,
>(
  params: ItemsV2ControllerAutocompleteParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerAutocomplete>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemsV2ControllerAutocomplete>>,
          TError,
          Awaited<ReturnType<typeof itemsV2ControllerAutocomplete>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemsV2ControllerAutocomplete<
  TData = Awaited<ReturnType<typeof itemsV2ControllerAutocomplete>>,
  TError = ErrorType<unknown>,
>(
  params: ItemsV2ControllerAutocompleteParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerAutocomplete>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 품목 자동완성 검색 (items-v2, 한글 유사 검색 .ilike, 최소 2자)
 */

export function useItemsV2ControllerAutocomplete<
  TData = Awaited<ReturnType<typeof itemsV2ControllerAutocomplete>>,
  TError = ErrorType<unknown>,
>(
  params: ItemsV2ControllerAutocompleteParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerAutocomplete>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getItemsV2ControllerAutocompleteQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 인기 품목 조회 (공급사 수 많은순, read-only)
 */
export const itemsV2ControllerGetPopular = (
  params?: ItemsV2ControllerGetPopularParams,
  signal?: AbortSignal,
) => {
  return api<ItemsV2ControllerGetPopular200>({
    url: `/items-v2/popular`,
    method: "GET",
    params,
    signal,
  });
};

export const getItemsV2ControllerGetPopularQueryKey = (
  params?: ItemsV2ControllerGetPopularParams,
) => {
  return [`/items-v2/popular`, ...(params ? [params] : [])] as const;
};

export const getItemsV2ControllerGetPopularQueryOptions = <
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetPopular>>,
  TError = ErrorType<unknown>,
>(
  params?: ItemsV2ControllerGetPopularParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetPopular>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getItemsV2ControllerGetPopularQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof itemsV2ControllerGetPopular>>
  > = ({ signal }) => itemsV2ControllerGetPopular(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof itemsV2ControllerGetPopular>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ItemsV2ControllerGetPopularQueryResult = NonNullable<
  Awaited<ReturnType<typeof itemsV2ControllerGetPopular>>
>;
export type ItemsV2ControllerGetPopularQueryError = ErrorType<unknown>;

export function useItemsV2ControllerGetPopular<
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetPopular>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ItemsV2ControllerGetPopularParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetPopular>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemsV2ControllerGetPopular>>,
          TError,
          Awaited<ReturnType<typeof itemsV2ControllerGetPopular>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemsV2ControllerGetPopular<
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetPopular>>,
  TError = ErrorType<unknown>,
>(
  params?: ItemsV2ControllerGetPopularParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetPopular>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemsV2ControllerGetPopular>>,
          TError,
          Awaited<ReturnType<typeof itemsV2ControllerGetPopular>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemsV2ControllerGetPopular<
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetPopular>>,
  TError = ErrorType<unknown>,
>(
  params?: ItemsV2ControllerGetPopularParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetPopular>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 인기 품목 조회 (공급사 수 많은순, read-only)
 */

export function useItemsV2ControllerGetPopular<
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetPopular>>,
  TError = ErrorType<unknown>,
>(
  params?: ItemsV2ControllerGetPopularParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetPopular>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getItemsV2ControllerGetPopularQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 
      공급사별 품목 단가 조회 (판매자 대시보드 견적 응답 시 자동 입력용)
      - 공급사의 최근 거래 단가 반환
      - 거래 이력이 없으면 null 반환
    
 * @summary 공급사별 품목 단가 조회
 */
export const itemsV2ControllerGetSupplierPrice = (
  params: ItemsV2ControllerGetSupplierPriceParams,
  signal?: AbortSignal,
) => {
  return api<ItemsV2ControllerGetSupplierPrice200>({
    url: `/items-v2/supplier-price`,
    method: "GET",
    params,
    signal,
  });
};

export const getItemsV2ControllerGetSupplierPriceQueryKey = (
  params?: ItemsV2ControllerGetSupplierPriceParams,
) => {
  return [`/items-v2/supplier-price`, ...(params ? [params] : [])] as const;
};

export const getItemsV2ControllerGetSupplierPriceQueryOptions = <
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetSupplierPrice>>,
  TError = ErrorType<unknown>,
>(
  params: ItemsV2ControllerGetSupplierPriceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetSupplierPrice>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getItemsV2ControllerGetSupplierPriceQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof itemsV2ControllerGetSupplierPrice>>
  > = ({ signal }) => itemsV2ControllerGetSupplierPrice(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof itemsV2ControllerGetSupplierPrice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ItemsV2ControllerGetSupplierPriceQueryResult = NonNullable<
  Awaited<ReturnType<typeof itemsV2ControllerGetSupplierPrice>>
>;
export type ItemsV2ControllerGetSupplierPriceQueryError = ErrorType<unknown>;

export function useItemsV2ControllerGetSupplierPrice<
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetSupplierPrice>>,
  TError = ErrorType<unknown>,
>(
  params: ItemsV2ControllerGetSupplierPriceParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetSupplierPrice>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemsV2ControllerGetSupplierPrice>>,
          TError,
          Awaited<ReturnType<typeof itemsV2ControllerGetSupplierPrice>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemsV2ControllerGetSupplierPrice<
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetSupplierPrice>>,
  TError = ErrorType<unknown>,
>(
  params: ItemsV2ControllerGetSupplierPriceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetSupplierPrice>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemsV2ControllerGetSupplierPrice>>,
          TError,
          Awaited<ReturnType<typeof itemsV2ControllerGetSupplierPrice>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemsV2ControllerGetSupplierPrice<
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetSupplierPrice>>,
  TError = ErrorType<unknown>,
>(
  params: ItemsV2ControllerGetSupplierPriceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetSupplierPrice>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 공급사별 품목 단가 조회
 */

export function useItemsV2ControllerGetSupplierPrice<
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetSupplierPrice>>,
  TError = ErrorType<unknown>,
>(
  params: ItemsV2ControllerGetSupplierPriceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetSupplierPrice>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getItemsV2ControllerGetSupplierPriceQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 
      특정 공급사가 과거에 거래한 모든 품목을 조회합니다.
      - 해당 공급사의 최근 거래 일자 순으로 정렬
      - 거래 이력이 있는 품목만 반환
      - 각 품목별 최근 거래 단가 포함
    
 * @summary 공급사별 거래 품목 조회
 */
export const itemsV2ControllerGetSupplierItems = (
  supplierId: string,
  signal?: AbortSignal,
) => {
  return api<ItemsV2ControllerGetSupplierItems200>({
    url: `/items-v2/supplier/${supplierId}/items`,
    method: "GET",
    signal,
  });
};

export const getItemsV2ControllerGetSupplierItemsQueryKey = (
  supplierId?: string,
) => {
  return [`/items-v2/supplier/${supplierId}/items`] as const;
};

export const getItemsV2ControllerGetSupplierItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetSupplierItems>>,
  TError = ErrorType<unknown>,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetSupplierItems>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getItemsV2ControllerGetSupplierItemsQueryKey(supplierId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof itemsV2ControllerGetSupplierItems>>
  > = ({ signal }) => itemsV2ControllerGetSupplierItems(supplierId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!supplierId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof itemsV2ControllerGetSupplierItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ItemsV2ControllerGetSupplierItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof itemsV2ControllerGetSupplierItems>>
>;
export type ItemsV2ControllerGetSupplierItemsQueryError = ErrorType<unknown>;

export function useItemsV2ControllerGetSupplierItems<
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetSupplierItems>>,
  TError = ErrorType<unknown>,
>(
  supplierId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetSupplierItems>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemsV2ControllerGetSupplierItems>>,
          TError,
          Awaited<ReturnType<typeof itemsV2ControllerGetSupplierItems>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemsV2ControllerGetSupplierItems<
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetSupplierItems>>,
  TError = ErrorType<unknown>,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetSupplierItems>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemsV2ControllerGetSupplierItems>>,
          TError,
          Awaited<ReturnType<typeof itemsV2ControllerGetSupplierItems>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemsV2ControllerGetSupplierItems<
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetSupplierItems>>,
  TError = ErrorType<unknown>,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetSupplierItems>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 공급사별 거래 품목 조회
 */

export function useItemsV2ControllerGetSupplierItems<
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetSupplierItems>>,
  TError = ErrorType<unknown>,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetSupplierItems>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getItemsV2ControllerGetSupplierItemsQueryOptions(
    supplierId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 로그인 전에는 공급사명·ID 를 «공급사 A» 같은 표식으로 가린다.
 * @summary 품목별 공급사 가격 비교 (단가 낮은순, read-only)
 */
export const itemsV2ControllerGetItemSupplierComparison = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ItemsV2ControllerGetItemSupplierComparison200>({
    url: `/items-v2/${id}/suppliers`,
    method: "GET",
    signal,
  });
};

export const getItemsV2ControllerGetItemSupplierComparisonQueryKey = (
  id?: string,
) => {
  return [`/items-v2/${id}/suppliers`] as const;
};

export const getItemsV2ControllerGetItemSupplierComparisonQueryOptions = <
  TData = Awaited<
    ReturnType<typeof itemsV2ControllerGetItemSupplierComparison>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetItemSupplierComparison>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getItemsV2ControllerGetItemSupplierComparisonQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof itemsV2ControllerGetItemSupplierComparison>>
  > = ({ signal }) => itemsV2ControllerGetItemSupplierComparison(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof itemsV2ControllerGetItemSupplierComparison>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ItemsV2ControllerGetItemSupplierComparisonQueryResult = NonNullable<
  Awaited<ReturnType<typeof itemsV2ControllerGetItemSupplierComparison>>
>;
export type ItemsV2ControllerGetItemSupplierComparisonQueryError =
  ErrorType<unknown>;

export function useItemsV2ControllerGetItemSupplierComparison<
  TData = Awaited<
    ReturnType<typeof itemsV2ControllerGetItemSupplierComparison>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetItemSupplierComparison>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof itemsV2ControllerGetItemSupplierComparison>
          >,
          TError,
          Awaited<ReturnType<typeof itemsV2ControllerGetItemSupplierComparison>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemsV2ControllerGetItemSupplierComparison<
  TData = Awaited<
    ReturnType<typeof itemsV2ControllerGetItemSupplierComparison>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetItemSupplierComparison>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof itemsV2ControllerGetItemSupplierComparison>
          >,
          TError,
          Awaited<ReturnType<typeof itemsV2ControllerGetItemSupplierComparison>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemsV2ControllerGetItemSupplierComparison<
  TData = Awaited<
    ReturnType<typeof itemsV2ControllerGetItemSupplierComparison>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetItemSupplierComparison>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 품목별 공급사 가격 비교 (단가 낮은순, read-only)
 */

export function useItemsV2ControllerGetItemSupplierComparison<
  TData = Awaited<
    ReturnType<typeof itemsV2ControllerGetItemSupplierComparison>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetItemSupplierComparison>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getItemsV2ControllerGetItemSupplierComparisonQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * items_v2_base 테이블에서 UUID로 품목 상세 정보 조회
 * @summary 품목 상세 조회 (UUID)
 */
export const itemsV2ControllerFindById = (id: string, signal?: AbortSignal) => {
  return api<ItemsV2ControllerFindById200>({
    url: `/items-v2/${id}`,
    method: "GET",
    signal,
  });
};

export const getItemsV2ControllerFindByIdQueryKey = (id?: string) => {
  return [`/items-v2/${id}`] as const;
};

export const getItemsV2ControllerFindByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof itemsV2ControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerFindById>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getItemsV2ControllerFindByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof itemsV2ControllerFindById>>
  > = ({ signal }) => itemsV2ControllerFindById(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof itemsV2ControllerFindById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ItemsV2ControllerFindByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof itemsV2ControllerFindById>>
>;
export type ItemsV2ControllerFindByIdQueryError = ErrorType<unknown>;

export function useItemsV2ControllerFindById<
  TData = Awaited<ReturnType<typeof itemsV2ControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerFindById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemsV2ControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof itemsV2ControllerFindById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemsV2ControllerFindById<
  TData = Awaited<ReturnType<typeof itemsV2ControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerFindById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemsV2ControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof itemsV2ControllerFindById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemsV2ControllerFindById<
  TData = Awaited<ReturnType<typeof itemsV2ControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerFindById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 품목 상세 조회 (UUID)
 */

export function useItemsV2ControllerFindById<
  TData = Awaited<ReturnType<typeof itemsV2ControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerFindById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getItemsV2ControllerFindByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 해당 품목의 네이버 쇼핑 최저가·최고가·평균가를 반환합니다. 24시간 캐시 적용.
 * @summary 네이버 쇼핑 시세 조회
 */
export const itemsV2ControllerGetMarketPrice = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<void>({
    url: `/items-v2/${id}/market-price`,
    method: "GET",
    signal,
  });
};

export const getItemsV2ControllerGetMarketPriceQueryKey = (id?: string) => {
  return [`/items-v2/${id}/market-price`] as const;
};

export const getItemsV2ControllerGetMarketPriceQueryOptions = <
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetMarketPrice>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetMarketPrice>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getItemsV2ControllerGetMarketPriceQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof itemsV2ControllerGetMarketPrice>>
  > = ({ signal }) => itemsV2ControllerGetMarketPrice(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof itemsV2ControllerGetMarketPrice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ItemsV2ControllerGetMarketPriceQueryResult = NonNullable<
  Awaited<ReturnType<typeof itemsV2ControllerGetMarketPrice>>
>;
export type ItemsV2ControllerGetMarketPriceQueryError = ErrorType<unknown>;

export function useItemsV2ControllerGetMarketPrice<
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetMarketPrice>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetMarketPrice>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemsV2ControllerGetMarketPrice>>,
          TError,
          Awaited<ReturnType<typeof itemsV2ControllerGetMarketPrice>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemsV2ControllerGetMarketPrice<
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetMarketPrice>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetMarketPrice>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemsV2ControllerGetMarketPrice>>,
          TError,
          Awaited<ReturnType<typeof itemsV2ControllerGetMarketPrice>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemsV2ControllerGetMarketPrice<
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetMarketPrice>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetMarketPrice>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 네이버 쇼핑 시세 조회
 */

export function useItemsV2ControllerGetMarketPrice<
  TData = Awaited<ReturnType<typeof itemsV2ControllerGetMarketPrice>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemsV2ControllerGetMarketPrice>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getItemsV2ControllerGetMarketPriceQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
